<template>
  <ais-stats class="my-stats">
    <template slot-scope="{ nbHits }">
      <span v-if="nbHits > 0">
        <span class="extra-text">You have </span>
        <span class="accent">{{ format(nbHits) }}</span>
        {{ results(nbHits) }}<span class="extra-text">.</span>
      </span>
      <span v-if="nbHits === 0"></span>
    </template>
  </ais-stats>
</template>

<script>
export default {
  methods: {
    results(nbHits) {
      return nbHits !== 1 ? 'results' : 'result';
    },
    format(number) {
      if ('NumberFormat' in Intl) {
        return new Intl.NumberFormat('en-UK').format(number);
      }
      return number;
    },
  },
};
</script>

<style scoped lang="scss">
.accent {
  @include theme-value(color, brand-color-one);
}

.my-stats {
  font-size: 15px;
  font-weight: 600;
  margin: 0.5em;
  text-transform: uppercase;
}

@media screen and (min-width: $tablet + 1) and (max-width: 900px) {
  .extra-text {
    display: none;
  }
}
</style>
